<template>
    <div>
        <div class="pre_chart_loader">
            <div style="font-size: 46px" v-if="typeChange=='pie-chart'"><i class="fa fa-pie-chart"></i></div>
            <div v-if="typeChange=='bar-chart'" style="font-size: 46px;color: #ccc;"><i class="fa fa-bar-chart-o"></i></div>
            <div style="font-weight: bold; color: #999;"><span>Chart Loading...<i class="fa fa-cog fa-spin"></i></span></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChartPreLoader",
        props:['typeChange']
    }
</script>

<style scoped>
    .pre_chart_loader{
        text-align: center;
        text-transform: capitalize;
    }
</style>